import { render, staticRenderFns } from "./community-panel.vue?vue&type=template&id=95c5fc00&scoped=true&"
import script from "./community-panel.ts?vue&type=script&lang=ts&"
export * from "./community-panel.ts?vue&type=script&lang=ts&"
import style0 from "./community-panel.scss?vue&type=style&index=0&id=95c5fc00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c5fc00",
  null
  
)

export default component.exports